export default from './BuyerCard';



// WEBPACK FOOTER //
// ./src/sharedComponents/BuyerCard/index.js